import React from 'react';
import SelectorPersonas from './SelectorPersonas';

/**
 * Paso 5 — Técnicos.
 *
 * Cambio de modelo (post-feedback de producción):
 *   Los técnicos SIEMPRE son internos, independientemente del ámbito de la
 *   campaña. El equipo técnico de la casa atiende tanto a empleados internos
 *   como a colaboradores externos.
 *
 *   Por eso pasamos `ambito="interno"` fijo al SelectorPersonas (no leemos
 *   payload.ambito). El selector busca en `personas` y permite filtros por
 *   negocio/departamento.
 *
 * Implicación: `tecnico_asignado_id` SIEMPRE apunta a `personas.Id`, sea cual
 * sea el ámbito. Reflejado en los joins del backend.
 */
export default function Paso5Tecnicos({ payload, errores, dispatch, dosColumnas = false }) {
  const esColaborador = payload.ambito === 'colaborador';

  return (
    <div className={dosColumnas ? 'space-y-3' : 'space-y-3 max-w-4xl'}>
      <p className="text-sm text-slate-500">
        Selecciona las personas que realizarán las intervenciones. Pueden ser
        de cualquier departamento, no solo de Sistemas.
        {esColaborador && (
          <>
            {' '}
            <span className="text-slate-600">
              Aunque esta campaña sea para colaboradores externos, los técnicos
              son personas internas de la casa.
            </span>
          </>
        )}
      </p>
      <SelectorPersonas
        rol="tecnico"
        ambito="interno"
        excluirIds={esColaborador ? [] : payload.usuarios_ids}
        seleccionados={payload.tecnicos_ids}
        cache={payload._tecnicos_cache}
        onAdd={(persona) =>
          dispatch({ type: 'PERSONA_ADD', rol: 'tecnico', persona })
        }
        onRemove={(id) =>
          dispatch({ type: 'PERSONA_REMOVE', rol: 'tecnico', id })
        }
        errores={errores}
        dosColumnas={dosColumnas}
      />
    </div>
  );
}
